import useCollection from "./useCollection"

export default function useViewableScheduledExports({ viewId, viewType }) {
  const viewable = viewType === "group" ? "view_groups" : "views"
  const key = `${viewable}/${viewId}/scheduled_exports`

  return useCollection({ key })
}
